import React, {FC} from "react";
import {
  Step,
  StepContent,
  StepLabel,
  Stepper as MUIStepper,
  Typography,
} from "@material-ui/core";
import clsx from "clsx";
import {useTheme} from "@material-ui/core/styles";
import useStyles from "./styles";

export type Step = {
  icon?: React.ReactElement;
  label: string;
  isActive?: boolean;
};
export type StepperProps = {
  orientation?: "horizontal" | "vertical";
  steps: Step[];
  activeStep: number;
  customLabelClass?: string;
  stepperClassName?: string;
  content?: React.ReactElement;
  nonLinear?: boolean;
  activeLabelTypographyClassName?: string;
  labelTypographyClassName?: string;
};

const Stepper: FC<StepperProps> = ({
  orientation,
  steps,
  activeStep,
  customLabelClass,
  content,
  nonLinear,
  stepperClassName,
  activeLabelTypographyClassName,
  labelTypographyClassName,
}) => {
  const theme = useTheme();
  const classes = useStyles();

  const renderData = () => {
    return steps.map(({icon, label, isActive}, index: number) => {
      const labelClassName = customLabelClass || "";
      const isVerticalOrientation = orientation === "vertical";

      const isStepActive = isActive || activeStep === index;
      const stepIconBackgroundColor = isStepActive
        ? theme.palette.primary.main
        : theme.palette.gray2.main;

      const stepIconProps = icon && {
        icon,
        style: {
          background: stepIconBackgroundColor,
          borderRadius: "100%",
        },
      };

      const typographyClassname =
        isStepActive && activeLabelTypographyClassName
          ? activeLabelTypographyClassName
          : labelTypographyClassName || classes.contrast;
      const key = `${index}-${label}`;
      return (
        <Step key={key}>
          <StepLabel
            classes={{label: labelClassName}}
            StepIconProps={stepIconProps}
          >
            <Typography
              className={clsx(
                isVerticalOrientation
                  ? classes.verticalLabel
                  : classes.horizontalLabel,
                typographyClassname
              )}
            >
              {label}
            </Typography>
          </StepLabel>
          {isVerticalOrientation && <StepContent>{content}</StepContent>}
        </Step>
      );
    });
  };

  return (
    <MUIStepper
      classes={{root: clsx(stepperClassName, classes.stepperBlock)}}
      nonLinear={nonLinear}
      orientation={orientation}
      activeStep={activeStep}
    >
      {renderData()}
    </MUIStepper>
  );
};

export {default as StepperImageContainer} from "./StepperImageContainer";
export default Stepper;
